import { env } from './env';

/**
 * Product switches for whole features. A feature that is off disappears from the UI (sidebar,
 * route, dashboard) while its code and API stay in place, so turning it back on is one line here.
 */
export interface FeatureFlags {
  /** Preispakete: named target margins per package (sidebar item, page, dashboard tile). */
  readonly pricingPackages: boolean;
  /** Tür-Assistent: chat on the plan page, switched with VITE_ASSISTANT like the backend's ASSISTANT_ENABLED. */
  readonly assistant: boolean;
}

export const features: FeatureFlags = {
  pricingPackages: false,
  assistant: env.VITE_ASSISTANT === 'true',
};
